module.exports = __webpack_public_path__ + "static/arrow-orange-dfdf79dc680995e643092a7876d55664.png";